export const useParagraphAnnotations = (
  annotations: RevisionAnnotations,
  paragraph: Paragraph,
  tokenGroup: ParagraphToken[],
  isBeforeParagraph: boolean
) => {
  var lastToken = tokenGroup[tokenGroup.length - 1];

  return annotations.filter((annotation: RevisionAnnotation) => {
    // If the annotation paragraph id matches and it's a before paragraph annotaiton return true otehr wise false

    if (isBeforeParagraph == true) {
      if (annotation.isBeforeParagraph == true) {
        return annotation.paragraphId == paragraph.id;
      }

      return false;
    }

    if (annotation.isStartLine == true) {
      return false;
    }

    if (annotation.isBeforeParagraph == true) {
      return false;
    }

    if (annotation.isEndLine == true) {
      // If force inline is false and the annotaiton is long then return true;
      if (
        annotation.forceInline != true &&
        annotation.paragraphId == paragraph.id &&
        useIsAnnotationCommentLong(annotation)
      ) {
        return true;
      }

      return false;
    }

    if (annotation.paragraphId != paragraph.id) {
      return false;
    }

    // If we're using the new method of assigning a lastTokenGlobal position to the annotaiton
    // Then we can check if it matches. Otherwise, because we've already matched the paragraph we return true
    if (lastToken && annotation.lastTokenGlobalPosition) {
      return annotation.lastTokenGlobalPosition == lastToken.globalPosition;
    }

    return true;
  });
};
